export default {"src":"/_next/static/media/ic-delete-answer.ad826aab.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};